<div class="content-block library-teacher__paginate">
  <div class="flex flex-col sm:items-center justify-center align-items-stretch sm:flex-row">
    <a class="mat-caption" href="#" (click)="showInfo($event)" i18n>What is Community Built?</a>
    <span class="flex-1 hidden sm:inline"></span>
    <mat-paginator
      [length]="filteredProjects.length"
      [pageSize]="pageSize"
      [pageSizeOptions]="pageSizeOptions"
      (page)="pageChange($event)"
    >
    </mat-paginator>
  </div>
  <mat-divider></mat-divider>
  <div class="library__list flex flex-col flex-wrap items-start sm:flex-row">
    <ng-container *ngFor="let project of filteredProjects; let i = index">
      <app-library-project
        *ngIf="isOnPage(i)"
        [project]="project"
        class="w-full sm:w-1/2 md:w-1/3 lg:w-1/4"
      />
    </ng-container>
    <div *ngIf="filteredProjects.length === 0" class="notice" i18n>
      No community designed units found.
    </div>
  </div>
  <mat-divider></mat-divider>
  <mat-paginator
    [length]="filteredProjects.length"
    [pageSize]="pageSize"
    [pageSizeOptions]="pageSizeOptions"
    (page)="pageChange($event, true)"
  >
  </mat-paginator>
</div>
